import { createSelector } from 'reselect';
import { getCurrentSiteUser } from '../../../../selectors/current-site-user';
import { getMainVideoId } from '@wix/wix-vod-shared/dist/src/widget/ui-selectors/selected-video-id';
import { getChannelForWidget } from '@wix/wix-vod-shared/dist/src/common/selectors/channels';
import { canPlayFullOrPreview } from '@wix/wix-vod-shared/dist/src/widget/ui-selectors/video-access';
import {
  isVideoFromComputer,
  isVideoOriginallyLive,
} from '@wix/wix-vod-shared/dist/src/common/ui-selectors/video/video-origin';

const getVideos = (state) => state.entities.videos;

/**
 * @param state
 * @param listType
 * @returns main video item
 */
const getMainVideo = createSelector(
  [getVideos, getMainVideoId],
  (videos, mainVideoId) => mainVideoId && videos[mainVideoId],
);

/**
 * @param state
 * @param listType
 * @returns {Boolean}
 */
export const canPlayVideoInFrame = createSelector(
  [getChannelForWidget, getMainVideo, getCurrentSiteUser],
  (channel, mainVideo, currentSiteUser) =>
    Boolean(
      mainVideo &&
        (isVideoFromComputer(mainVideo) || isVideoOriginallyLive(mainVideo)) &&
        canPlayFullOrPreview(channel, mainVideo, currentSiteUser),
    ),
);
